module.exports = __webpack_public_path__ + "img/04.6d4992c0.png";